import React from "react";
import getProperty from "lodash-es/get";
import { createElement, PureComponent } from "react";
import { columnPropType, rowPropType } from "./propTypes";
import { getCellClassName } from "./utils";
export default class DataTableBodyCell extends PureComponent {
  static propTypes = {
    column: columnPropType.isRequired,
    row: rowPropType.isRequired,
  };

  render() {
    const { className, column, row, ...otherProps } = this.props;
    const { name, format, component } = column;
    const compositeClassName = getCellClassName(column, className, true);
    let value = getProperty(row, name);

    if (format) {
      value = format(value, row);
    }

    if (component) {
      value = createElement(component, {
        value,
        row,
      });
    }

    return (
      <td className={compositeClassName} {...otherProps}>
        {value}
      </td>
    );
  }
}
